import Vue from "vue";
import App from "./App.vue";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import { AMBIENTE } from '../public/config.json';

// Import Bootstrap an BootstrapVue CSS files (order is important)

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import router from "./router";

// Make BootstrapVue available throughout your project

Vue.use(BootstrapVue);

// Optionally install the BootstrapVue icon components plugin

Vue.use(IconsPlugin);

Vue.config.productionTip = false;

/* interceptor */

import { http } from "./interceptor/http";

/*  Installazione Editor Kendo  */

import "@progress/kendo-ui";
import "@progress/kendo-theme-default/dist/all.css";
import { EditorInstaller } from "@progress/kendo-editor-vue-wrapper";

Vue.use(EditorInstaller);

/* loader */

import VueLoading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

fetch(`${process.env.BASE_URL}config.json`)
  .then((resp) => resp.json())
  .then((data) => {
    Vue.prototype.$configJson = data;
    http.defaults.baseURL =  process.env[`VUE_APP_API_${AMBIENTE}`];
    Vue.use(VueLoading, { loader: "dots", color: "#188483" });
    new Vue({
      router,
      render: (h) => h(App),
    }).$mount("#app");
  });
